module.exports = __webpack_public_path__ + "img/home_business_item4_1.805ba78d.jpg";